/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Askquestion_Button2Inputs */

const en_coinvestments_messages_askquestion_button2 = /** @type {(inputs: Coinvestments_Messages_Askquestion_Button2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ask question`)
};

/**
* | output |
* | --- |
* | "Ask question" |
*
* @param {Coinvestments_Messages_Askquestion_Button2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_askquestion_button2 = /** @type {((inputs?: Coinvestments_Messages_Askquestion_Button2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Askquestion_Button2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_askquestion_button2(inputs)
});
export { coinvestments_messages_askquestion_button2 as "coInvestments_messages_askQuestion_button" }